module.exports = __webpack_public_path__ + "img/PoweredByBlack.665b6d97.png";